import React from 'react';
import { MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0d0d0d] border-t border-[#3f4816] py-12 md:py-16">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Left Section */}
          <div className="flex flex-col items-start gap-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_gym-photography/artifacts/m7mn43sp_Fit%20Frame%20Logo.svg"
              alt="FIT-FRAME Logo"
              className="h-12 w-auto"
            />
            <p className="font-['DM_Sans'] text-[#888680] text-xs">
              by Offline Capture · Ahmedabad, Gujarat
            </p>
          </div>

          {/* Right Section */}
          <div className="text-left md:text-right">
            <p className="font-['DM_Sans'] text-[#888680] text-sm">
              © {new Date().getFullYear()} FIT-FRAME. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
